import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {Layout as AppLayout} from 'src/layouts/app';
import {paths} from "src/paths";

const SummaryReportPage = lazy(() => import('src/pages/report/summary'));
const SurveyorReportPage = lazy(() => import('src/pages/report/surveyor'));
const ClaimReportPage = lazy(() => import('src/pages/report/claim'));
const EnquiryReportPage = lazy(() => import('src/pages/report/enquiry'));
const CloseClaimReportPage = lazy(() => import('src/pages/report/close-claim'));
const MonitorReportPage = lazy(() => import('src/pages/report/monitor'));


export const ReportRoutes = [
    {
        path: 'report',
        element: (
            <AppLayout>
                <Suspense>
                    <Outlet/>
                </Suspense>
            </AppLayout>
        ),
        children: [
            {
                path: paths.report.summaryReport,
                element: <SummaryReportPage/>
            },
            {
                path: paths.report.surveyorReport,
                element: <SurveyorReportPage/>
            },
            {
                path: paths.report.claimReport,
                element: <ClaimReportPage/>
            },
            {
                path: paths.report.enquiryReport,
                element: <EnquiryReportPage/>
            },
            {
                path: paths.report.closeClaimReport,
                element: <CloseClaimReportPage/>
            },
            {
                path: paths.report.monitor,
                element: <MonitorReportPage/>
            },
        ]
    }
];
